import { Component } from 'react';
import '../Styles/TextField.css';

export default class TextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cur_num : '',
      has_error: props.error ? true : false,
      error_message: props.error ? props.error : 'placeholder',
      fieldId: props.id ? props.id : "fieldId"
    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    // automatically selects the text field
    var input = document.getElementById(this.state.fieldId);
    input.focus();
    input.select();
    input.setSelectionRange(0, 9999);
  }

  handleChange(event) {
    var text = this.limit_text(event.target.value);

    if(this.props.update_text){
      this.props.update_text(text);
    }
    this.setState({value: text});
  }

  limit_text(text){
    if(this.props.limits !== undefined){
      return text.replace(/\D/g,'')
    }
    return text 
  }

  //If there are numerical limits passed into 
  //the text field for acceptable input this function
  //checks whether the text is between these limits
  within_limit(number) {
    if(number > this.props.limits.lower && number < this.props.limits.upper) {
      return true;
    }
    return false;
  }

  //handles checking on text from parent
  check_limits(text){
    if(!text){
      return text
    }

    var formatted = this.limit_text(text).toUpperCase()
    var old_val = this.state.cur_num

    if(String(formatted) !== String(old_val)){

      this.setState({cur_num: String(formatted)});

      if(this.props.limits !== undefined){
        this.props.update_answered(this.within_limit(Number(formatted)))
      }

      if (text !== formatted){
        this.props.update_text(formatted);
        this.setState({value: String(formatted)});
      }

    }
    return formatted
  }


  render(){
    return (
      <div className={this.props.bare ? 'bareOuter' : 'outerFieldContainer'}>
        <div  className={this.props.bare? 'bareContainer' : 'fieldContainer'}>   
          <div className='frontLabel'>
          {this.props.frontLabel ? <p>{this.props.frontLabel}</p> : null}
          <input 
            className={this.props.error ? 'fieldErrorBorder': this.props.small ? 'smallField' : 'field'}
            type={this.props.type ? this.props.type : "text"} // or "number" for numeric keyboard on Android
            id={this.state.fieldId}
            value={this.check_limits(this.props.text)} 
            onChange={this.handleChange}
            placeholder={this.props.placeholder}
            readOnly={this.props.readOnly}
            autoFocus={this.props.focus}
            // pattern="[0-9]*" --> used to bring up numeric keyboard on iOS
          />
          </div>       
          <div>
            <p className='label'>{this.props.label}</p>
          </div>
        </div>
        <div className={this.props.error ? 'fieldError': 'noError'}>
          {this.props.error ? this.props.error : 'placeholder'}
        </div>
      </div>
    );
  }
}